import { html, type TemplateResult } from 'lit';
import { classMap } from 'lit/directives/class-map.js';

import { renderExternalEmbedGate } from '../common/external-embed-gate.js';

export interface FigmaEmbedOptions {
  url: string;
  /** The reader released the Figma file for this view. */
  loaded: boolean;
  onLoad: () => void;
  overlayHidden: boolean;
}

export function figmaEmbedUrl(url: string): string {
  return `https://www.figma.com/embed?embed_host=blocksuite&url=${url}`;
}

/**
 * Figma area of the block: the external-content placeholder until the reader
 * loads the file, then the Figma viewer.
 */
export function renderFigmaEmbed({
  url,
  loaded,
  onLoad,
  overlayHidden,
}: FigmaEmbedOptions): TemplateResult {
  if (!loaded) {
    return html`<div class="affine-embed-figma-iframe-container">
      ${renderExternalEmbedGate({
        provider: 'figma',
        previewImageUrl: null,
        onLoad,
      })}
    </div>`;
  }

  return html`<div class="affine-embed-figma-iframe-container">
    <iframe
      src=${figmaEmbedUrl(url)}
      allowfullscreen
      loading="lazy"
      credentialless
    ></iframe>

    <!-- overlay to prevent the iframe from capturing pointer events -->
    <div
      class=${classMap({
        'affine-embed-figma-iframe-overlay': true,
        hide: overlayHidden,
      })}
    ></div>
  </div>`;
}
